import { InternalMessageRequest, MarkMessageRead, Message, MessageRequest, MessagesReassignmentsDto, RecalledMessageDto } from "../types/Message";
import { UserDto } from "../types/User";
import apiClient from "../utils/apiClient";

export const getNotifications = async (messageRequest?: MessageRequest): Promise<Message[]> => {
    const response = await apiClient.post<Message[]>(`/portal/message/notifications-list`, messageRequest);
    return response.data;
};

export const getInternalMessages = async (request?: InternalMessageRequest): Promise<Message[]> => {
    const response = await apiClient.post<Message[]>(`/portal/message/messages-list`, request);
    return response.data;
};

export const getInternalReplyMessages = async (conversationId: number | null, filterByUserId?: number | null, upToMessageId?: number | null): Promise<Message[]> => {
    const params = new URLSearchParams();
    if (filterByUserId) params.append('filterByUserId', String(filterByUserId));
    if (upToMessageId) params.append('upToMessageId', String(upToMessageId));
    const queryString = params.toString() ? `?${params.toString()}` : '';
    const response = await apiClient.get<Message[]>(`/portal/message/reply-messages/${conversationId}${queryString}`);
    return response.data;
}

export const markMessageAsRead = async (request?: MarkMessageRead): Promise<boolean> => {
    const response = await apiClient.post<boolean>(`/portal/message/update-message`, request);
    return response.data;
};

export const insertMessage = async (formData: FormData): Promise<Message> => {
    const response = await apiClient.post<Message>(`/portal/message/insert-messages`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const getMessagesUnreadCount = async (): Promise<number> => {
    const response = await apiClient.get<number>(`/portal/message/notifications-unreadCount`);
    return response.data;
}

export const getInternalMessagesUnreadCount = async (): Promise<number> => {
    const response = await apiClient.get<number>(`/portal/message/messages-unreadCount`);
    return response.data;
}

export const downloadAttachment = async (attachmentId: number): Promise<Blob> => {
    const response = await apiClient.get(`/portal/message/download/${attachmentId}`, {
        responseType: 'blob',
    });
    return response.data;
};

export const getActiveUsersWithPermission = async (): Promise<UserDto[]> => {
    const response = await apiClient.get<UserDto[]>(`/portal/ShareResource/active-users-module`);
    return response.data;
}

export const reassignMessage = async (request?: MessagesReassignmentsDto): Promise<MessagesReassignmentsDto[]> => {
    const response = await apiClient.post<MessagesReassignmentsDto[]>(`/portal/message/reassign-message`, request);
    return response.data;
};

export const recallMessage = async (request?: RecalledMessageDto): Promise<boolean> => {
    const response = await apiClient.post<boolean>(`/portal/message/recall-message`, request);
    return response.data;
};

